import { Navigate, redirect } from "react-router-dom";
import "./CustomerRow.scss";
import { useState } from "react";

export default function CustomerRow({ customer }) {
  const [showPopup, setShowPopup] = useState(false);

  const popupHandler = (e) => {
    setShowPopup((state) => !state);
    e.preventDefault();
  };

  return (
    <div className="customer-row">
      <h2 className="customer-row__field">{customer.firstName}</h2>
      <h2 className="customer-row__field">{customer.lastName}</h2>
      <h2 className="customer-row__field">{customer.key}</h2>
      <h2 className="customer-row__field">{customer.expressedIn}</h2>
      <h2 className="customer-row__field">{customer.createAt}</h2>
      <h2 className="customer-row__field no-center" onClick={popupHandler}>
        {customer.comment}
      </h2>
      {showPopup && (
        <div onClick={popupHandler} className="customer-row__popup">
          <p className="customer-row__popup-text">{customer.comment}</p>
        </div>
      )}
    </div>
  );
}
